import { Action } from '@ngrx/store';

import { SurveyActionType } from './survey-action-type.enum';


export class SelectSurvey implements Action {
  public readonly type: SurveyActionType = SurveyActionType.SelectSurvey;

  constructor(public readonly payload: number) { }
}

export class SelectSurveyCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.SelectSurveyCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectSurveyFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.SelectSurveyFailed;

  constructor(public readonly payload: string) { }
}
